import { render, staticRenderFns } from "./ProjectValuationScoreTableTotalRow.vue?vue&type=template&id=9678fac0&"
import script from "./ProjectValuationScoreTableTotalRow.vue?vue&type=script&lang=ts&"
export * from "./ProjectValuationScoreTableTotalRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports